import React from "react";
import moment from "moment";
import { LogIn, MapPin, Clock } from "lucide-react";

export default function LoginCard({ item }) {
  return (
    <div className="rounded-2xl mt-2 border-2 border-[var(--hover)] bg-[var(--background)] p-4 shadow-sm transition-all duration-300">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[var(--background)] border-2 border-[var(--hover)] flex items-center justify-center text-white">
            <LogIn className="text-[var(--buy)]" size={20} />
          </div>
          <div>
            <p className="text-base font-medium text-[var(--text)]">
              {item.device || "Unknown Device"}
            </p>
          </div>
        </div>
        <p className="text-xs text-[var(--subtext)] font-medium">
          {moment(item.time).format("DD MMM, YYYY")}
        </p>
      </div>

      <div className="mt-3 flex items-center gap-4 text-sm text-[var(--subtext)]">
        <div className="flex items-center gap-1">
          <Clock className="text-[var(--subtext)]" size={14} />
          <span>{moment(item.time).format("hh:mm A")}</span>
        </div>
        {item.ip && (
          <div className="flex items-center gap-1">
            <MapPin className="text-[var(--subtext)]" size={14} />
            <span>{item.ip}</span>
          </div>
        )}
      </div>
    </div>
  );
}
